"use client";
import React, { useState, useEffect } from "react";
import { MdDelete } from "react-icons/md";
import { CiEdit } from "react-icons/ci";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { tableCellClasses } from "@mui/material/TableCell";
import s from "./notificationPage.module.css"; // Reuse the CSS module
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Pagination,
} from "@mui/material";
import { notificationHandler } from "../../utils/Notification";
import Loder from "../../Loder/Loder";
import { BiArrowBack, BiFilter, BiSearch } from "react-icons/bi";
import DataNotFound from "../ErrorPage/DataNotFound";
import { IoMdAdd } from "react-icons/io";
import { getNotificationHistory_api } from "../api/notification";

const NotificationHistory = () => {
  const navigate = useNavigate();
  const [isLoading, setisLoading] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [pageCount, setpageCount] = useState(1);
  const [deleteId, setdeleteId] = useState("");
  const [deletePopup, setdeletePopup] = useState(false);
  const [currentNotification, setCurrentNotification] = useState({});
  const [pageLength, setpageLength] = useState();
  const [search, setsearch] = useState("");
  const [totalData, setTotalData] = useState("");
  const [limit, setLimit] = useState(10);

  useEffect(() => {
    fetchNotificationHistory();
  }, [pageCount, search, limit]);

  async function fetchNotificationHistory() {
    setisLoading(true);
    try {
      const temp = {
        page: pageCount,
        limit: limit,
        search: search.trim(),
      };
      let res = await getNotificationHistory_api(temp);
      if (res.data.success) {
        setNotifications(res.data.data);
        setpageLength(res.data.pagination.totalPages);
        setTotalData(res.data.pagination.total);
        setisLoading(false);
      } else {
        setisLoading(false);
        console.log("status false!");
      }
    } catch (error) {
      console.log(error);
    }
  }

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "var(--clr-theme)",
      color: theme.palette.common.white,
      fontWeight: "bold",
      borderRight: "1px solid #fff",
      overflow: "hidden",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      border: "none",
      borderLeft: "2px solid #00000011",
      "&:last-child": {
        borderRight: "2px solid #00000011",
      },
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    borderBottom: "2px solid #00000011",
  }));

  return (
    <div className="">
      <div className="beat_heading">
        <div className={s["user-list-heading"]}>
          <div className="user-list-title">
            <h3>Notification History</h3>
          </div>
           <div className={s["title"]} onClick={() => navigate(-1)}>
                    <BiArrowBack/> Back
                  </div>
          <div className={s["user-list-search"]}>
            <div className={s["search-box"]}>
              <span style={{ paddingRight: "0.5rem" }}>
                <BiSearch size={23} />
              </span>
              <input
                type="text"
                spellCheck="false"
                onChange={(e) => {
                  setpageCount(1);
                  setsearch(e.target.value);
                }}
                placeholder="Search notifications by title.."
              />
            </div>
          </div>
        </div>
      </div>
      <div className="beat_table" style={{ overflowX: "auto" }}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell align="center">Title</StyledTableCell>
              <StyledTableCell align="center">Message</StyledTableCell>
              <StyledTableCell align="center">Image</StyledTableCell>
              <StyledTableCell align="center">Redirect</StyledTableCell>
              <StyledTableCell align="center">Redirect Model</StyledTableCell>
              <StyledTableCell align="center">Redirect ID</StyledTableCell>
              <StyledTableCell align="center">Admin Name</StyledTableCell>
              <StyledTableCell align="center">Created At</StyledTableCell>
              {/* <StyledTableCell align="center">Action</StyledTableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {notifications?.map((row) => (
              <StyledTableRow key={row._id}>
                
                <StyledTableCell align="center">{row.title}</StyledTableCell>
                <StyledTableCell align="center">{row.message}</StyledTableCell>
                <StyledTableCell align="center">
                  {row.image ? (
                    <img
                      src={row.image}
                      alt="Notification Image"
                      style={{ width: "100px", height: "auto" }}
                    />
                  ) : (
                    "No Image"
                  )}
                </StyledTableCell>
                <StyledTableCell align="center">{row.redirect}</StyledTableCell>
                <StyledTableCell align="center">{row.redirectModel}</StyledTableCell>
                <StyledTableCell align="center">{row.redirectId || "N/A"}</StyledTableCell>
                <StyledTableCell align="center">{row.admin_id.name}</StyledTableCell>
                <StyledTableCell align="center">
                  {new Date(row.created_at).toLocaleString()}
                </StyledTableCell>
                {/* Add actions if needed */}
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
        {notifications?.length <= 0 && <DataNotFound />}
      </div>
      {notifications?.length > 0 && (
        <div className={s["pagination"]}>
          <Pagination
            count={pageLength}
            size="large"
            style={{ color: "#D21903" }}
            onChange={(e, value) => setpageCount(value)}
            page={pageCount}
          />
        </div>
      )}
      <Loder loading={isLoading} />
    </div>
  );
};

export default NotificationHistory;